exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sign_wrap[data-v-58332266]{width:1042px;min-height:820px;margin:80px auto;border:1px solid #eee;position:relative;padding:70px 50px}.start_btn[data-v-58332266]{position:absolute;top:-52px;right:0}.intro[data-v-58332266],.up_info[data-v-58332266]{font-size:14px;color:#333}.intro p[data-v-58332266],.up_info p[data-v-58332266]{line-height:30px}.fwb[data-v-58332266]{font-weight:700}.q_and_a[data-v-58332266]{list-style:none}.q_and_a .questions[data-v-58332266]{line-height:22px}.questions[data-v-58332266]:hover{cursor:pointer;color:#4db7eb;text-decoration:underline}.tab[data-v-58332266]{margin-top:20px;border:1px dotted #c4c4c4;text-align:center;padding:10px}.text_intro[data-v-58332266]{text-indent:2em}.actives[data-v-58332266]{color:#4db7eb;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-58332266","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/sign/intro.vue
// module id = 384
// module chunks = 0